import Notfound from "features/notFound/NotFound";
import { ComponentType, FC, lazy, LazyExoticComponent } from "react";
import { TypeOfSupportEnum } from "utils/enums/TypeOfSupportEnum";
import { TypeOfTravelSimEnum } from "utils/enums/TypeOfTravelSimEnum";
import { InjectionToken } from "utils/injectionToken/InjectionToken";

export interface IAppPages {
  Component: LazyExoticComponent<FC<any> | ComponentType>;
  token?: symbol | string;
  addtionalProps?: unknown;
}

class AppPages {
  static PageKeys: Record<string, IAppPages> = {
    GeneralFeature: {
      Component: lazy(() => import("features/generals/views/GeneralFeature")),
    },
    AppSimMobifoneFeature: {
      Component: lazy(
        () =>
          import(
            "features/mobiSimRegistration/views/MobiSimRegistrationFeature"
          )
      ),
      token: InjectionToken.MobiSimRegistrationViewModel,
    },
    AirTimeRegistrationFeature: {
      Component: lazy(
        () =>
          import(
            "features/airTimeRegistration/views/AirTimeRegistrationFeature"
          )
      ),
      token: InjectionToken.AirTimeRegistrationViewModel,
    },
    AppDataRegisterFeature: {
      Component: lazy(
        () =>
          import(
            "features/packageRegistration/views/PackageRegistrationFeature"
          )
      ),
      token: InjectionToken.PackageRegistrationViewModel,
    },
    AppNiceSimFeature: {
      Component: lazy(
        () =>
          import(
            "features/niceSimRegistration/views/NiceSimRegistrationFeature"
          )
      ),
      token: InjectionToken.NiceSimRegistrationViewModel,
    },
    InboundTravelSimFeature: {
      Component: lazy(
        () =>
          import(
            "features/travelSimRegistration/views/TravelSimRegistrationFeature"
          )
      ),
      token: InjectionToken.TravelSimRegistrationViewModel,
      addtionalProps: TypeOfTravelSimEnum.inbound,
    },
    OutboundTravelSimFeature: {
      Component: lazy(
        () =>
          import(
            "features/travelSimRegistration/views/OutboundRegistrationFeature"
          )
      ),
      token: InjectionToken.OutboundRegistrationViewModel,
      addtionalProps: TypeOfTravelSimEnum.outbound,
    },
    CashFlowFeature: {
      Component: lazy(() => import("features/cashFlow/views/CashFlowFeature")),
      token: InjectionToken.CashFlowViewModel,
    },
    PackageLookupFeature: {
      Component: lazy(
        () => import("features/supportFeature/views/PackageLookupFeature")
      ),
      token: InjectionToken.SupportFeatureViewModel,
      addtionalProps: TypeOfSupportEnum.viewPlan,
    },
    SimLookupFeature: {
      Component: lazy(
        () => import("features/supportFeature/views/SimLookupFeature")
      ),
      token: InjectionToken.SupportFeatureViewModel,
      addtionalProps: TypeOfSupportEnum.viewSim,
    },
    ApiDocManagementFeature: {
      Component: lazy(
        () => import("features/supportFeature/views/ApiDocumentFeature")
      ),
      token: InjectionToken.ApiDocumentViewModel,
      addtionalProps: TypeOfSupportEnum.apiDoc,
    },
    DispatchManagementFeature: {
      Component: lazy(
        () => import("features/supportFeature/views/OfficialDispatchFeature")
      ),
      token: InjectionToken.ApiDocumentViewModel,
      addtionalProps: TypeOfSupportEnum.officialDispatch,
    },
    StoreManagementFeature: {
      Component: lazy(
        () => import("features/storeManagement/views/StoreManagementFeature")
      ),
    },
    StaffManagementFeature: {
      Component: lazy(
        () => import("features/storeManagement/views/StaffManagementFeature")
      ),
    },
  };

  static getPage(key: string): any {
    return this.PageKeys[key]?.Component || Notfound;
  }

  static getToken(key: string) {
    return this.PageKeys[key]?.token;
  }

  static getAddtionalProps(key: string) {
    return this.PageKeys[key]?.addtionalProps;
  }
}

export default AppPages;
